<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Angular Maven Plugin</h1>
					<p waBody="m" waText>Maven build plugin that drives the full Angular build lifecycle &mdash; discovers &#64;NgApp classes, generates .ts sources, installs npm dependencies, provisions Node.js and the Angular CLI, executes the production build, and optionally produces a Docker image with nginx. Uses a flat URLClassLoader with parent-first delegation for reliable classpath resolution in the Maven plugin context.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Maven Plugin</wa-tag>
						<wa-tag pill variant="neutral">Angular CLI</wa-tag>
						<wa-tag pill variant="neutral">Docker</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:angular-maven-plugin</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.angular.maven</p>
					<p waBody="s" waText>Built on: Maven / Angular CLI 3.9.6+ / 20</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_66" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Maven goal jwebmp-angular:build &mdash; compiles TypeScript for every &#64;NgApp on classpath &#40;default phase: install&#41;</p>
					<p waBody="s" waColorText="quiet" waText>Flat URLClassLoader with parent-first delegation and automatic classpath deduplication</p>
					<p waBody="s" waColorText="quiet" waText>Configurable classpath scope &mdash; runtime &#40;default&#41;, compile, test, packaged/package/artifact</p>
					<p waBody="s" waColorText="quiet" waText>Explicit app selection via &lt;appClasses&gt; or auto-discovery of all &#64;NgApp implementations</p>
					<p waBody="s" waColorText="quiet" waText>Optional npm install with --force flag support</p>
					<p waBody="s" waColorText="quiet" waText>Optional Node.js/npm toolchain provisioning with configurable version &#40;default 20.18.1&#41;</p>
					<p waBody="s" waColorText="quiet" waText>Optional Angular CLI provisioning with configurable version</p>
					<p waBody="s" waColorText="quiet" waText>Optional production build execution &#40;ng build&#41;</p>
					<p waBody="s" waColorText="quiet" waText>Docker image generation &mdash; auto-generates Dockerfile and nginx.conf, or uses custom files</p>
					<p waBody="s" waColorText="quiet" waText>Nginx HTTPS support with TLS certificates, HTTP-to-HTTPS redirect, and custom server directives</p>
					<p waBody="s" waColorText="quiet" waText>Configurable Docker base image &#40;default nginx:alpine&#41;, image name, and build arguments</p>
					<p waBody="s" waColorText="quiet" waText>Configurable output directory via outputDirectory parameter</p>
					<p waBody="s" waColorText="quiet" waText>Skip support via &lt;skip&gt;true&lt;/skip&gt; or -Djwebmp.angular.skip=true</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Full Build with Docker Image</h4>
						<p waBody="s" waColorText="quiet" waText>Generate TypeScript, install dependencies, build Angular, and produce a Docker image in one Maven run.</p>
						<markdown [data]="mdContent_67" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>HTTPS with Custom Nginx Configuration</h4>
						<p waBody="s" waColorText="quiet" waText>Enable HTTPS in the generated nginx.conf with TLS certificates and custom directives.</p>
						<markdown [data]="mdContent_68" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Explicit App Selection</h4>
						<p waBody="s" waColorText="quiet" waText>Build only specific &#64;NgApp classes instead of auto-discovering all.</p>
						<markdown [data]="mdContent_69" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_70" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>CONFIGURATION</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>skip</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Skip the entire plugin execution &#40;-Djwebmp.angular.skip&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>classpathScope</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Maven classpath scope &mdash; runtime, compile, test, packaged/package/artifact</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: runtime</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>outputDirectory</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Base output directory for generated TypeScript sources</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: $&#123;project.build.directory&#125;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>appClasses</h4>
							<wa-tag pill variant="neutral">List&lt;String&gt;</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Explicit list of &#64;NgApp fully-qualified class names to build</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;auto-discover&#41;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>installDependencies</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Run npm install during build &#40;-Djwebmp.angular.install&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>installForce</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Run npm install --force &#40;-Djwebmp.angular.install.force&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>ensureToolchain</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Provision Node.js/npm if not found &#40;-Djwebmp.angular.ensureToolchain&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>downloadNpm</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Download npm separately during toolchain provisioning &#40;-Djwebmp.angular.downloadNpm&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nodeVersion</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Node.js version to provision &#40;-Djwebmp.angular.nodeVersion&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: 20.18.1</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>angularCliVersion</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Angular CLI version to provision &#40;-Djwebmp.angular.angularCliVersion&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;latest&#41;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>buildAngular</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Run ng build after code generation &#40;-Djwebmp.angular.build&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>buildDockerImage</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Build an OCI/Docker image containing the Angular build served by nginx &#40;-Djwebmp.angular.docker&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>dockerImageName</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Docker image name &#40;repository:tag&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: $&#123;artifactId&#125;:$&#123;version&#125;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>dockerBaseImage</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Base image for the generated Dockerfile</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: nginx:alpine</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>dockerfilePath</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Path to an existing Dockerfile &mdash; skips generation when set</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;generated&#41;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>dockerBuildArgs</h4>
							<wa-tag pill variant="neutral">List&lt;String&gt;</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Additional arguments passed to docker build &#40;e.g. --no-cache, --build-arg&#41;</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;none&#41;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxHttps</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Enable HTTPS server block &#40;port 443&#41; with TLS in generated nginx.conf</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: false</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxSslCertificate</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Path to SSL certificate inside the container</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: /etc/nginx/ssl/server.crt</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxSslCertificateKey</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Path to SSL private key inside the container</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: /etc/nginx/ssl/server.key</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxHttpRedirect</h4>
							<wa-tag pill variant="neutral">boolean</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>301 redirect HTTP to HTTPS when nginxHttps is enabled</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: true</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxServerName</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>The server&#95;name directive in generated nginx.conf</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: localhost</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxCustomEntries</h4>
							<wa-tag pill variant="neutral">List&lt;String&gt;</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Raw nginx directives injected into the server block</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;none&#41;</div>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<h4 waHeading="s" waText>nginxConfigFile</h4>
							<wa-tag pill variant="neutral">String</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Path to an existing nginx.conf &mdash; skips generation when set</p>
						<div waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Default: &#40;generated&#41;</div>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9.6+</wa-tag>
						<wa-tag pill variant="neutral">Docker &#40;optional, for image generation&#41;</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://angular.dev/tools/cli</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/Angular</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>